import { AloftPrice, isDefined, schAlertType, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';
import { getScopedAlertType } from '../utils/compTypeScoping.ts';

export const conditionAdjustedUpAgainstSubject: AlertDefinition = ({
  compAdjustments,
  compSequence,
  compType,
  propertyDataEntities,
  order,
}) => {
  if (!order.isInspectifyOrder) return undefined;

  const subjectConditionValue = (
    propertyDataEntities.subject as SubjectPropertyDataState | undefined
  )?.subjectData.editableData.improvements.uadCondition;
  const subjectCondition = isDefined(subjectConditionValue) ? subjectConditionValue : undefined;
  if (!subjectCondition) return undefined;

  const faultyComp = compSequence
    .map((id, index) => {
      const compConditionValue = (propertyDataEntities[id] as CompPropertyDataState | undefined)
        ?.compData.editableData.improvements.uadCondition;
      const compCondition = isDefined(compConditionValue) ? compConditionValue : undefined;

      const conditionAdjustment = compAdjustments[id]?.condition.adjustment;
      const isAdjustedUp = !!conditionAdjustment && conditionAdjustment.gt(AloftPrice.zero);

      return { id, index, compCondition, isAdjustedUp };
    })
    .find(
      ({ compCondition, isAdjustedUp }) =>
        isAdjustedUp && isDefined(compCondition) && compCondition < subjectCondition,
    );

  if (!faultyComp) return undefined;

  const { index, compCondition } = faultyComp;
  const compNumber = index + 1;

  const message = `Comparable ${compNumber} is adjusted up, despite having a higher condition rating than the Subject (Comparable ${compNumber}: C${compCondition} | Subject: C${subjectCondition}).`;

  return {
    type: getScopedAlertType(schAlertType.enum.conditionAdjustedUpAgainstSubject, compType),
    status: 'active' as const,
    message,
    ...(compType ? { compType } : {}),
    fixingInfo: {
      tips: 'Tips: The condition adjustment appears to be going in the wrong direction. Consider changing the adjustment direction, or updating the condition rating of the Comparable to be lower than the Subject.',
      pairedCostRouteItem: schPairedCostRouteItem.enum['adjustments-grid'],
    },
  };
};
